import { format } from 'date-fns';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../../Button/index.js';
import { Popover } from '../../Popover/index.js';
import { DatePicker } from '../date_picker/date_picker.js';
import { useDateFormat } from '../hooks/useDateFormat.js';
import { useMinMaxDate } from '../hooks/useMinMaxDate.js';
import { MAX_DATE, MIN_DATE } from '../utilities/constants.js';
/**
 * Select a date.
 *
 * `DatePickerDialog` is the most common interaction and should work out of the box for most use cases. If you need something a bit
 * different, use the lower-level components `DatePicker`, `Calendar`, and/or `DateInput` to customize the interaction.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { DatePickerDialog } from "@panwds/react-ui";
 * ```
 */
export const DatePickerDialog = ({ className, button, dataMetrics, dataTestId, initialActiveDate, label, dateFormat = 'PP', defaultPlacement = 'bottom-start', fullWidth = false, max: propsMax = MAX_DATE, min: propsMin = MIN_DATE, onApply, selectedDate, showLabel, weekStartsOn, disabled = false, placeholder, childLabel }) => {
    const intl = useIntl();
    const { pattern } = useDateFormat(dateFormat);
    const { min, max } = useMinMaxDate({ max: propsMax, min: propsMin, pattern });
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(Popover, { addClassName: "[&>div]:twds-max-h-fit", addPopoverClassName: className, dataMetrics: dataMetrics, dataTestId: dataTestId || 'date-picker-dialog', button: button || (React.createElement(Button, { fullWidth: fullWidth, isMenu: true, disabled: disabled }, selectedDate && format(selectedDate, pattern))), defaultPlacement: defaultPlacement, label: label ??
            intl.formatMessage({
                defaultMessage: 'Select a date',
                id: '4Mab4D',
                description: 'Label to select a date'
            }), showLabel: showLabel, isOpen: isOpen, onIsOpenChange: setIsOpen },
        React.createElement(DatePicker, { initialActiveDate: initialActiveDate, initialDate: selectedDate, max: max, min: min, disabled: disabled, onApply: (nextDate) => {
                onApply(nextDate);
                setIsOpen(false);
            }, dateFormat: pattern, onCancel: () => setIsOpen(false), weekStartsOn: weekStartsOn, placeholder: placeholder, label: childLabel })));
};
//# sourceMappingURL=date-picker-dialog.js.map